const ItemNoQueryParam = 'itemNo' as const

export default ItemNoQueryParam

